/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 */

const SOCIAL_PORTALS = new Set(['facebook', 'instagram']);
const LISTING_PORTALS = new Set(['olx', 'zap', 'vivareal', 'chavesnamao']);

/**
 * Determines whether the connected portals include any social network.
 *
 * @param connectedPortals - Portal identifiers the agency has connected.
 * @returns True when at least one social network portal is present.
 */
export function hasSocialPortalConnection(connectedPortals: string[]): boolean {
  return connectedPortals.some((portal) => SOCIAL_PORTALS.has(portal));
}

/**
 * Determines whether the connected portals include any listing portal
 * (OLX, ZAP, Viva Real, Chaves na Mão).
 *
 * @param connectedPortals - Portal identifiers the agency has connected.
 * @returns True when at least one listing portal is present.
 */
export function hasListingPortalConnection(connectedPortals: string[]): boolean {
  return connectedPortals.some((portal) => LISTING_PORTALS.has(portal));
}
